import axios from 'axios';
import cacheStorage from '../../utils/cacheStorage';
import { initialMockAdmins } from './MockData';

const BASE_URL = 'https://smart-cargo-backend-923182991420.us-central1.run.app';

const getAuthHeaders = () => {
  const token = cacheStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const globalSearch = async (query, userRole) => {
  if (!query) return [];

  const lowerQuery = query.toLowerCase();
  const results = [];

  // Search Packages (real API)
  try {
    const res = await axios.get(`${BASE_URL}/api/packages`, { headers: getAuthHeaders() });
    const packages = res.data || [];
    packages.forEach(pkg => {
      if (
          pkg.tracking_code?.toLowerCase().includes(lowerQuery) ||
          (pkg.delivery_address?.String || '').toLowerCase().includes(lowerQuery) ||
          (pkg.customer_name?.String || '').toLowerCase().includes(lowerQuery) ||
          (pkg.courier_name?.String || '').toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          id: pkg.id,
          type: 'Package',
          title: pkg.id,
          subtitle: `${pkg.customer_name?.String || 'Unknown'} → ${pkg.delivery_address?.String || 'Unknown'}`,
          path: '/admin/packages',
          rawData: pkg
        });
      }
    });
  } catch (e) {
    console.warn('Package search failed:', e);
  }

  // Search Couriers (real API)
  try {
    const res = await axios.get(`${BASE_URL}/api/admin/couriers`, { headers: getAuthHeaders() });
    const couriers = res.data || [];
    couriers.forEach(c => {
      const formattedId = `CUR-${String(c.id).padStart(3, '0')}`;
      if (
          c.name?.toLowerCase().includes(lowerQuery) ||
          formattedId.toLowerCase().includes(lowerQuery) ||
          c.phone?.toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          id: formattedId,
          type: 'Courier',
          title: c.name,
          subtitle: c.phone || formattedId,
          path: '/admin/couriers',
          rawData: c
        });
      }
    });
  } catch (e) {
    console.warn('Courier search failed:', e);
  }

  // Search Vehicles (real API)
  // Raw API fields: { id (numeric), plate_no, model, ... }
  // VehiclesPage remaps: { id: plate_no, type: model }
  // So result.id must be plate_no to match VehiclesPage's ?search= lookup
  try {
    const res = await axios.get(`${BASE_URL}/api/vehicles`, { headers: getAuthHeaders() });
    const vehicles = res.data || [];
    vehicles.forEach(vehicle => {
      if (
          vehicle.plate_no?.toLowerCase().includes(lowerQuery) ||
          vehicle.model?.toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          id: vehicle.plate_no,
          type: 'Vehicle',
          title: vehicle.plate_no,
          subtitle: vehicle.model,
          path: '/admin/vehicles',
          rawData: vehicle
        });
      }
    });
  } catch (e) {
    console.warn('Vehicle search failed:', e);
  }

  // Search Warehouses (real API)
  // Raw API fields: { id (numeric), name, address, ... }
  // WarehousesPage remaps: { id: `WH10${id}`, name, location: address }
  // So result.id must use the same WH10 format to match WarehousesPage's ?search= lookup
  try {
    const res = await axios.get(`${BASE_URL}/api/warehouses`, { headers: getAuthHeaders() });
    const warehouses = res.data || [];
    warehouses.forEach(warehouse => {
      const formattedId = `WH10${warehouse.id}`;
      if (
          warehouse.name?.toLowerCase().includes(lowerQuery) ||
          formattedId.toLowerCase().includes(lowerQuery) ||
          (warehouse.address || '').toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          id: formattedId,
          type: 'Warehouse',
          title: warehouse.name,
          subtitle: warehouse.address || formattedId,
          path: '/admin/warehouses',
          rawData: warehouse
        });
      }
    });
  } catch (e) {
    console.warn('Warehouse search failed:', e);
  }

  // Search Admins — mock only, no real API (master admin only)
  if (userRole === 'master admin') {
    initialMockAdmins.forEach(admin => {
      if (
          admin.name.toLowerCase().includes(lowerQuery) ||
          admin.id.toLowerCase().includes(lowerQuery) ||
          admin.email.toLowerCase().includes(lowerQuery)
      ) {
        results.push({
          id: admin.id,
          type: 'Admin',
          title: admin.name,
          subtitle: admin.email,
          path: '/admin/admins',
          rawData: admin
        });
      }
    });
  }

  return results;
};